// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Flex, Typography } from '@iheartjane/reefer';
import type { ColorKey } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

const Badge = styled(Box)({
  borderRadius: 80,
  padding: 32,
  textAlign: 'center',
  backdropFilter: 'blur(16px)',
  width: 'fit-content',
});

export type JumboDiscountBadgeProps = PropsWithChildren<{
  color: ColorKey;
  textColor: ColorKey;
}>;

export const JumboDiscountBadge = ({
  children,
  color = 'gold',
  textColor = 'grays-black',
}: JumboDiscountBadgeProps) => (
  <Badge background={color}>
    <Flex justifyContent="center" alignItems="center">
      <Typography color={textColor} variant="h2-semibold" branded>
        {children}
      </Typography>
    </Flex>
  </Badge>
);
